export default __webpack_public_path__ + "8b72189d23a3d16f58acfe2c434687e8.png";